import React, { memo, useCallback, useMemo } from 'react';
import EntityLink from 'components/EntityLink';
import { OPPORTUNITIES } from 'constants/Entities';
import DetailField from 'containers/components/EntityDetailPopover/DetailField';
import useEntityDetail from 'containers/components/EntityDetail/hooks/useEntityDetail';
import { stopEntityNavigation } from 'utils/entityNavigation';
import { canViewEntity } from 'utils/entityPermissions';
import { getOpportunityDetailUrl } from 'utils/getUrl';

const OpportunityField = memo(({ data, onClick }) => {
    const { hasTabsEnabled, openTab } = useEntityDetail();

    const handleOnClick = useCallback(
        (e) => {
            if (!canViewEntity(OPPORTUNITIES)) return stopEntityNavigation(e);
            if (!hasTabsEnabled || e.ctrlKey) return true;

            e.stopPropagation();
            e.preventDefault();

            onClick && onClick();

            openTab({
                entity: OPPORTUNITIES,
                id: data.idExpediente?.value,
                hasCrudInDetail: true,
                toTab: false,
                avoidRedirects: true,
            });
        },
        [data?.idExpediente?.value, hasTabsEnabled, onClick, openTab],
    );

    const component = useMemo(() => {
        if (!data.idExpediente) return null;
        return (
            <EntityLink
                entity={OPPORTUNITIES}
                href={getOpportunityDetailUrl(data.idExpediente.value)}
                onClick={handleOnClick}
                linkProps={{ className: 'fm-agenda-small-detail__link', target: 'blank' }}
                textProps={{ className: 'fm-agenda-small-detail__link' }}
            >
                {data.idExpediente.label}
            </EntityLink>
        );
    }, [data, handleOnClick]);

    if (!data.idExpediente) return null;

    return <DetailField iconProps={{ name: 'opportunities' }} component={component} />;
});

export default OpportunityField;
